import { CommonModal } from "../../../AbstractElements";
import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Form, FormGroup, Label } from "reactstrap";
import { useForm, useController } from "react-hook-form";
import CityTransferComp from "./CityTransferComp";

import { toast } from "react-toastify";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";
import DatePicker from "react-datepicker";
import {
  PhoneNumberLabel,
  CustomerNameLabel,
  Vip,
  Corporate,
  City,
  Instructions,
  Email,
  DateTime,
  CityToAirport,
  AirportToCity,
  CityToCity,
} from "../../../Constant/index";
import CustomSelect from "../../../CommonElements/CustomSelect";
import { getCarTypes, getCorporateClients, getCorporateClientsBySeviceCityIdWithoutPagination, getCorporatePackagesByServiceCity, getPackagesByServiceCity, getUserDetails, showAlert, getAggregatorData } from "../../../Services/Shared.service";
import AirportTransferComp from "./AirportTransferComp";
import { applyCoupon, editTripData, fetchFareEstimation, fetchLocation, findPickupType, getCoupons, postBooking, searchCoupon, getApplicableOffers, applyOffer } from "../../../Services/Booking.service";
import moment from "moment";
import CabDetails from "./CabDetails";
import CouponsModal from "./CouponsModal";
import { getExternalThirdPartyListings, getPackagesListExt } from "../../../Services/ExternalThirdParty.service";



const BookEdit = (props) => {
    // usestate
    const [pickupDate, setPickupDate] = useState(new Date());
      //   to store corporate list
      const [corporateClientData, setCorporateClientData] = useState([]);
      const [thirdPartyClientData, setThirdPartyClientData] = useState([]);
    //  usestates-----------------
    const cityData = props.cityData ? props.cityData : [];
    const [dateValidation, setDateValidation] = useState({
        error: false,
        message: null,
      });
    const [minDate, setMinDate] = useState(new Date());
    const [travelType, setTravelType] = useState(AirportToCity);
    // ========== toggle adresss
    const [toggleAddress, setToggleAddress] = useState(false);
    const [airportCityData, setAirportCityData] = useState([]);
    const airportData = props.airportData ? props.airportData : [];
    // after adress selection estimation calculation
    const [estimatedData, setEstimatedData] = useState([]);
    const [selectedCoupon, setSelectedCoupon] = useState({});
    const [carDetails, setCarDetails] = useState([]);
    const [paymentMode, setPaymentMode] = useState(null);
    // ---package select
    const [packagesData, setPackagesData] = useState([]);
    const [selectedPackage, setSelectedPackage] = useState();
    // -------car type
    const [carTypeData, setCarTypeData] = useState([]);
    // coupon
    const [couponsData, setCouponsData] = useState([]);
    const [offersData, setOffersData] = useState([]);
    const [selectedOffer, setSelectedOffer] = useState({});
    const [editTrip, setEditTrip] = useState(false);
    const [isCouponOpen, setIsCouponOpen] = useState(false);

    const [bookingType, setBookingType] = useState("");
    const [count, setCount] = useState(1)
    const [isInitialFreezed, setIsInitialFreezed] = useState(false);
    const [handleToggle, setHandleToggle] = useState(false);
    const [aggregatorList, setAggregatorList] = useState([]);
    const [selectedAggregator, setSelectedAggregator] = useState([]);
    const {
        register,
        handleSubmit,
        control,
        reset,
        resetField,
        getValues,
        setValue,
        watch,
        formState: { errors },
      } = useForm();
      
      const {sourceAddressDropdown, airportDropdown} = watch(); 
      const cityField = useController({
        name: "city",
        control,
        rules: {
          required: {
            value: true,
            message: "City is Required",
          },
        },
      }).field;
    
      const destAddressField = useController({
        name: "destAddressDropdown",
        control,
      }).field;
    
      const sourceAddressField = useController({
        name: "sourceAddressDropdown",
        control,
      }).field;
    
      const corporateClientField = useController({
        name: "corporateClient",
        control,
      }).field;

      const aggregatorField = useController({
        name: "aggregatorDropDown",
        control,
      }).field;
    
    
      const airportField = useController({
        name: "airportDropdown",
        control,
      }).field;
    
      const packageField = useController({
        name: "packageDropdown",
        control,
      }).field;

      const customerTypeWatch= watch("customerType");

      // const destAddress = useController({
      //   name: "destAddress",
      //   control,
      // }).field;
    
    useEffect(() => {
      setEditTrip(() => {
        return props?.editType == "Edit" ? true : false;
      });
      setBookingType(() => {
        return props?.editType ? props?.editType : "Book";
      });
      const pickupType =  props?.bookingData?.pickupType ?? AirportToCity

      setTravelType(pickupType);

      setToggleAddress(() => {
        return pickupType == CityToAirport ? true : false;
      });
        if(true){
            reset({
                phoneNumber: props?.bookingData?.custMobile || props?.bookingData?.custAlternateNo || "",
                customerName: props?.bookingData?.custName || "",
                instructions: props?.bookingData?.remark || "",
                email: props?.bookingData?.custEmail || "",
                custId: props?.bookingData?.custId || null,
                gender: props?.bookingData?.gender || "M",
                isMoveToComplete: props?.bookingData?.isMoveToComplete
                  ? props?.editType && props?.editType == "Rebook"
                    ? "false"
                    : props?.bookingData?.isMoveToComplete
                  : "false",
                city:checkCity(),
                customerType:checkCustomerType(),
                destAddressDropdown:checkDestAddress(pickupType),
                corporateClient:checkCorporateClient(),
                thirdPartyClientId:props?.bookingData?.thirdPartyClientId||"",
                // sourceAddressDropdown: checkSourceAddress(pickupType),
                airportDropdown:checkAirPort(pickupType),
                currentBookingStatusType: props?.bookingData?.currentBookingStatusType
                  ? props?.editType && props?.editType == "Rebook"
                    ? "New"
                    : props?.bookingData?.currentBookingStatusType
                  : "New",
                bookingViaType: props?.bookingData?.bookingViaType
                  ?  props?.bookingData?.bookingViaType
                  : "CallCenter",
                createdByUserType: props?.bookingData?.createdByUserType
                  ? props?.editType && props?.editType == "Rebook"
                    ? "CallTaker"
                    : props?.bookingData?.createdByUserType
                  : "CallTaker",
                packageDropdown:checkPacketData(),
                // destAddressDropdown: null,
                sourceAddressDropdown: null,
                aggregatorId : checkAggregator(),
                // airportDropdown: null,
                zone:props?.bookingData.zone|| "",
              });
            
            //   date set helper
            setPickupDate(() => {
                return props?.bookingData?.pickUpDateTime
                  ? props?.editType && props?.editType == "Rebook"
                    ? new Date().setHours(new Date().getHours() + 1)
                    : new Date(props?.bookingData?.pickUpDateTime)
                  : new Date().setHours(new Date().getHours() + 1);
              });

            setMinDate(() => {
                return props?.bookingData?.pickUpDateTime
                  ? props?.editType && props?.editType == "Rebook"
                    ? new Date()
                    : new Date(props?.bookingData?.pickUpDateTime)
                  : new Date();
              });

        }
        
        getCorporateClients().then((result) => {
          if (result.status == 200 && result.data.length > 0) {
            const data = result.data.map((element) => {
              return {
                value: element,
                label: element.companyName,
              };
            });
            setCorporateClientData(data);
          }
        });
        getExternalThirdPartyListings().then((result) => {
          if (result.status == 200 && result.data.list.length > 0) {
            const data = result.data.list.map((element) => {
              return {
                value: element,
                label: element.companyName,
              };
            });
            setThirdPartyClientData(data);
          }
        });
// NEW
        getAggregatorData().then((result) => {
          if (result.status == 200 && result.data.length > 0) {
            const data = [
              {
                value: null,
                label: "None",
              },
              ...result.data.map((element) => {
                return {
                  value: element,
                  label: element.companyName,
                };
              }),
            ];
            console.log(">>>>>> Aggregator ::", result);
            setAggregatorList(data);
          }
        });

            // ------ helper initalisers calls -------------
        settingAirportCityDatas()
        // checkDestAddress(pickupType)
        checkSourceAddress(pickupType)
        // fetchaddress()
        console.log("fetch11","reset")
      

        
        // set selected car
        checkCar()
        
        // packageManager()
        // cityfieldSideeffect()

       
        
    setPaymentMode(() => {
      return props?.bookingData?.paymentModeType
        ? props?.bookingData?.paymentModeType
        : null;
    });
    if (props?.bookingData?.couponId) {
      console.log("props?.bookingData?.couponId", props?.bookingData?.couponId);
      setSelectedCoupon({
        couponId: props?.bookingData?.couponId,
        discountedFinalFare: props?.bookingData?.finalFare,
        code: props?.bookingData?.couponCode,
        discountedEstimateFare: props?.bookingData?.discountedEstimateFare,
      });
    }
    let a= watch()
    console.log("eroro",a)
    estimationInitializer()

    setIsInitialFreezed(true)
  
    }, [props.bookingData])
// --------------------------------------------xxx----------------------------------------


// useEffect(() => {
//   console.log("weare >>","traveltype >>>>",travelType,)
//   console.log("weare >>>>","toggleAddress >>>>>>",toggleAddress)
//   console.log("weare >>> answer", travelType == AirportToCity ||CityToAirport 
//     ? toggleAddress
//       ? "CallCenter"
//       : "AirportBooking"
//     : "CallCenter",)
// }, [toggleAddress])


let estimationInitializer=()=>{
  
  const dataObject=[ {
    estimatedMinFare: props?.bookingData?.discountedEstimateFare,
    estimatedMinKM: props?.bookingData?.bookingTotalDistance,
    overviewPolyline:props?.bookingData?.overviewPolyline,
    estimatedKm: props?.bookingData?.estimatedKm,
    carTypeId: props?.bookingData?.carTypeId,
    active:true
  }]
  setEstimatedData(dataObject)
}

useEffect(() => {
  if (
    props.Large &&
    props?.bookingData?.couponId
  ) {
   couponApply(props.bookingData?.couponCode, props.bookingData?.couponId,props.bookingData?.carTypeId)
  }
}, [estimatedData])

    // helpers====
    const checkCar=()=>{
      let obj = [];
      if (props?.bookingData?.carTypeId) {
        obj.push({
          id: props?.bookingData?.carTypeId,
          count: 1,
        });
       
      }
    
      setCarDetails(obj);
    }
    const checkCity = () => {
        let city = undefined;
        if (props?.bookingData?.serviceCityId && cityData.length > 0) {
          city = cityData.find(
            (element) => element.value.id == props?.bookingData.serviceCityId
          );
          if (city && Object.keys(city).length > 0) {
            return city?.value
          }
        }
        return city?.value
      };
      const checkAggregator = () => {
        let aggregator = null;
        if (props?.bookingData?.aggregatorId && aggregatorList.length > 0) {
          console.log(">>>> AGGREGATOR LIST IS ::: ", aggregatorList)
          aggregator = aggregatorList.find(
            (element) => element.value !== null ? element.value.id == props?.bookingData?.aggregatorId : ''
          );
          if (aggregator && Object.keys(aggregator).length > 0) {
            return aggregator?.value
          }
        }
        console.log(">>>> AGGREGATOR VALUE IN CHECK AGGREGATOR  IS :: ", aggregator);
        
        setSelectedAggregator(aggregator?.value)
        return aggregator?.value
      };

      const checkCustomerType = () => {
        if (props?.bookingData?.isVip) {
          return "Vip"
        } else if (props?.bookingData?.isCompanyBooking) {
          return "Corporate"
        } else if(props?.bookingData?.thirdPartyClientId){
          return "thirdPartyClient"
        }else {
          return "Standard"
        }
      };
      // ------
      let checkPacketData=()=>{
        
         if(props.bookingData.packageId && props.bookingData.packageName ){
          let data={ id:props.bookingData.packageId,name:props.bookingData.packageName }
                    return {...data}
          
         }else{
         
        return   null
         }
      }
      // -------

      const checkCorporateClient = () => {
        // let corporateClient = undefined;
        if (
          props?.bookingData?.isCompanyBooking &&
          props?.bookingData?.corporateClientId
        ) {
          return {
            id: props?.bookingData?.corporateClientId,
            companyName: props?.bookingData?.companyName
          }
        } else {
          return null
        }
      };    
      const settingAirportCityDatas=()=>{
        const serviceId = props?.bookingData?.serviceCityId;
        if (serviceId) {
          let array = [];
          airportData.forEach((element) => {
            if (element.serviceCityId == serviceId) {
              array.push({
                value: element,
                label: element.name,
              });
            }
          });
          setAirportCityData(array);
        }
      }
      const checkAirPort = (pickupType) => {
        let airport = null;
        if (pickupType == AirportToCity || pickupType == CityToCity) {
          if (props?.bookingData?.pickUpAddress) {
            airport = {
              name: props?.bookingData.pickUpAddress,
              lat: props?.bookingData?.pickUpLat,
              lng: props?.bookingData?.pickUpLng,
            };
          }
        } else {
          console.log(pickupType, "pickupType");
          if (props?.bookingData?.destAddress) {
            airport = {
              name: props?.bookingData?.destAddress,
              lat: props?.bookingData?.destLat,
              lng: props?.bookingData?.destLng,
            };
          }
        }
    
        return {...airport}
        //  airportField.onChange(airport);
      };

      const checkDestAddress = (pickupType) => {
        let destAddress = undefined;
        if (pickupType == AirportToCity || pickupType == CityToCity) {
          if (props?.bookingData?.destAddress) {
            destAddress = {
              address: props?.bookingData?.destAddress,
              lat: props?.bookingData?.destLat,
              lng: props?.bookingData?.destLng,
            };
          }
        } else {
          if (props?.bookingData?.pickUpAddress) {
            destAddress = {
              address: props?.bookingData.pickUpAddress,
              lat: props?.bookingData?.pickUpLat,
              lng: props?.bookingData?.pickUpLng,
            };
          }
        }
     
        return {...destAddress}
      };
        // console.log("checker", destAddressField.value)

      const getPickupType =  () => {
        if (props?.bookingData?.pickupType) return props?.bookingData?.pickupType;
    
        const destLat = props?.bookingData?.destLat;
        const destLng = props?.bookingData?.destLng;
        const pickUpLat = props?.bookingData?.pickUpLat;
        const pickUpLng = props?.bookingData?.pickUpLng;
        if (!destLat || !destLng || !pickUpLat || !pickUpLng) return AirportToCity;
    
        // let obj = { destLat, destLng, pickUpLat, pickUpLng };
        // return findPickupType(obj)
        //   .then((result) => {
       
        //     if (result.data) {
        //       return result.data;
        //     }
        //   })
        //   .catch((err) => {
        //     return AirportToCity;
        //   });
      };


      const checkSourceAddress = (pickupType) => {
        let sourceAddress = null;
        if (pickupType == AirportToCity || pickupType == CityToCity) {
          if (props?.bookingData?.pickUpAddress) {
            sourceAddress = {
              address: props?.bookingData.pickUpAddress,
              lat: props?.bookingData?.pickUpLat,
              lng: props?.bookingData?.pickUpLng,
            };
          }
        } else {
          if (props?.bookingData?.destAddress) {
            sourceAddress = {
              address: props?.bookingData?.destAddress,
              lat: props?.bookingData?.destLat,
              lng: props?.bookingData?.destLng,
            };
          }
        }
        console.log("fetch1",sourceAddress)
         setValue("sourceAddressDropdown",sourceAddress);
      };
      // coupon search 
      const couponSearch = (couponCode) => {
        const rideType =
          travelType == AirportToCity ? (toggleAddress ? "C2A" : "A2C") : "C2C";
        const obj = {
          couponCode,
          serviceCityId: cityField.value?.id ? cityField.value?.id : null,
          rideType,
        };
        searchCoupon(obj)
          .then((resp) => {
            couponApply(resp.data.code, resp.data.id, carDetails[0].id);
          })
          .catch((err) => {
            showAlert(
              "error",
              err.response.data.message
                ? err.response.data.message
                : "Something went wrong"
            );
          });
      };

      // Estemation calculation
      const calculateEstimation = (pickupObj, destObj) => {
       


        if (!pickupObj.address || !destObj.address) return;
        console.log(pickupObj.address,destObj.address ,"checker 2")
        let body = {
          pickupLat: pickupObj?.lat,
          pickupLng: pickupObj?.lng,
          destLat: destObj?.lat,
          destLng: destObj?.lng,
          isPackage:getValues("packageDropdown")?.id ? true : false,
          packageId: getValues("packageDropdown")?.id,
          serviceCityId:getValues("city")?.id ? getValues("city")?.id : null,
          bookingSourceType: "TMS",
          customerMobile: getValues("phoneNumber")
        };
        // let a=watch()
        // console.log(a,"checker 3")
        if (pickupObj.lat && destObj.lat) {
          fetchFareEstimation(body)
            .then((result) => {
              console.log("pickuop----", result);
              if (result.data) {
                const fareData = [];
                let hasOffer = false;
                result.data.forEach((element) => {
                  const fare = element.finalFare;
                  const distance = packageField.value?.id
                    ? element.estimatedDistanceInKmOnly
                    : element.estimatedMinKM;
                  if (element.discountedEstimateFare != null && element.discountedEstimateFare !== 0) {
                    hasOffer = true;
                  }
                  fareData.push({
                    ...element,
                    carTypeId: element.carTypeId,
                    estimatedMinFare: fare,
                    baseFare: element.estimatedMinFare,
                    active: fare || fare == 0 ? true : false,
                    estimatedMinKM: distance,
                  });
                });
                // console.log(fareData, "fareData");
                setEstimatedData(fareData);
              } else {
                clearFareData();
                
              }
            })
            .catch((err) => {
              showAlert(
                "error",
                err.response.data.message
                  ? err.response.data.message
                  : "Cannot Calculate fare for given location"
              );
              clearFareData();
            });
        }
      };

      const clearFareData = () => {
        packageField.onChange("")
        setEstimatedData([]);
        setSelectedCoupon({});
        setSelectedOffer({});
        console.log("123"," clearfare data")
        setCarDetails([]);
        setPaymentMode(null)
      };
      
      const fetchAddressData = () => {
        var now = moment(new Date()); // current datetime
        var end = moment(pickupDate);
        const duration = moment.duration(end.diff(now));
        const timeDiff = duration.asMinutes();

        console.log("fetch1 addd>>>getValues>>>>sourceAddressDropdown>",sourceAddressDropdown)
        console.log("fetch1 addd>>>getValues>>>>airportDropdown>",airportDropdown)
        console.log("fetch1 addd>>>travelType>>>>>",travelType)

        const sourceAddress =
        travelType == CityToCity ? getValues("sourceAddressDropdown") : getValues("airportDropdown");

        const destAddress =getValues("destAddressDropdown");
        if (travelType == AirportToCity || travelType == CityToAirport) {
          let rideType = "AirportPickup";
          let pickupObj = {
            address: sourceAddress?.name,
            lat: Number(sourceAddress?.lat),
            lng: Number(sourceAddress?.lng),
          };
          let destObj = {
            address: destAddress?.address,
            lat: Number(destAddress?.lat),
            lng: Number(destAddress?.lng),
          };
          if (toggleAddress) {
            // rideType = timeDiff >= 45 ? "RideLater" : "RideNow";
            rideType = "RideLater";
            pickupObj = {
              address: destAddress?.address,
              lat: Number(destAddress?.lat),
              lng: Number(destAddress?.lng),
            };
            destObj = {
              address: sourceAddress?.name,
              lat: Number(sourceAddress?.lat),
              lng: Number(sourceAddress?.lng),
            };
          }
          console.log("logs",pickupObj, destObj, rideType )
          return { pickupObj, destObj, rideType };
        } else {
          // let rideType = timeDiff >= 45 ? "RideLater" : "RideNow";
          let rideType = "KurbPickup";
          let pickupObj = {
            address: sourceAddress?.address,
            lat: Number(sourceAddress?.lat),
            lng: Number(sourceAddress?.lng),
          };
          let destObj = {
            address: destAddress?.address,
            lat: Number(destAddress?.lat),
            lng: Number(destAddress?.lng),
          };
          console.log("logs 2",pickupObj, destObj, rideType )
          return { pickupObj, destObj, rideType };
        }
      };

      const couponApply = (code, couponId, selectedCarId) => {
      
        const fareObj = estimatedData.find(
          (element) => element.carTypeId == selectedCarId
        );
        console.log("coupon123","estimate--",fareObj,"code==",code,"id--", couponId,"selected--", selectedCarId)
        if (fareObj?.baseFare || fareObj?.baseFare == 0) {
          const rideType =
            travelType == AirportToCity ? (toggleAddress ? "C2A" : "A2C") : "C2C";
          const obj = {
            code: code,
            estimatedFare: fareObj.baseFare,
            couponId: couponId,
            serviceCityId: getValues("city")?.id? getValues("city")?.id: null,
            rideType,
            convenienceCharge: fareObj.convenienceCharge,
            bookingFees: fareObj.bookingFees,
            isPackage:getValues("packageDropdown")?.id  ? true : false,
            packageId:getValues("packageDropdown")?.id  ?getValues("packageDropdown")?.id  : null,
            rateId: fareObj.rateId,
          };
          applyCoupon(obj)
            .then((resp) => {
              console.log("123", "apply coupon")
              setSelectedCoupon(resp.data);
              setSelectedOffer({});  // mutual exclusivity
              setIsCouponOpen(false);
              showAlert("success", "Coupon applied Successfully");
            })
            .catch((err) => {
              setSelectedCoupon({});  // clear stale data on failure
              showAlert(
                "error",
                err.response?.data?.message
                  ? err.response.data.message
                  : "Something went wrong"
              );
            });
        }
      };

      const offerApply = (offerCode, selectedCarId) => {
        const fareObj = estimatedData.find(
          (element) => element.carTypeId == selectedCarId
        );
        if (!fareObj?.baseFare) return;
        const custId = getValues("custId");
        if (!custId) {
          showAlert("error", "Please select a customer before applying an offer");
          return;
        }
        const isAirportBooking = AirportToCity ? toggleAddress ? false : true : false;
        const obj = {
          offerCode,
          customerId: custId,
          rateId: fareObj.rateId,
          estimatedFare: fareObj.baseFare,
          distance: fareObj.estimatedMinKM || 0,
          bookingFees: fareObj.bookingFees,
          convenienceCharge: fareObj.convenienceCharge,
          isAirportBooking,
        };
        applyOffer(obj)
          .then((resp) => {
            setSelectedOffer(resp.data);
            setSelectedCoupon({});  // mutual exclusivity
            setIsCouponOpen(false);
            showAlert("success", "Offer applied Successfully");
          })
          .catch((err) => {
            setSelectedOffer({});  // clear stale data on failure
            showAlert(
              "error",
              err.response?.data?.message || "Something went wrong"
            );
          });
      };


      // -------helpers useeffects----------

      // set distination adress
      useEffect(() => {
        console.log("use effect",10,"fetch loca")
        if (destAddressField.value?.address) {
          setValue("destAddress", destAddressField.value?.address);
        } else if (destAddressField.value) {
          let obj = {
            key: null,
            isAgentApp: true,
            geoApi: true,
            address: destAddressField.value,
            requestSource: "TMS"
          }
          fetchLocation(obj).then((result) => {
            if (result && Array.isArray(result.data) && result.data.length > 0) {
              destAddressField.onChange(result.data[0])
            }
          });
        } else {
          setValue("destAddress", "");
        }
      }, [destAddressField.value]);

      //  source address change -- or initializer logic
      useEffect(() => {
        if (sourceAddressField.value?.address) {
          setValue("sourceAddress", sourceAddressField.value?.address);
        } else if (sourceAddressField.value) {
          let obj = {
            key: null,
            isAgentApp: true,
            geoApi: true,
            address: sourceAddressField.value,
            requestSource: "TMS"
          }
          fetchLocation(obj).then((result) => {
            if (result.data.length > 0) {
              sourceAddressField.onChange(result.data[0])
            }
          });
        } else {
          setValue("sourceAddress", "");
        }
      }, [sourceAddressField.value]);

    // ==============call estemation api caller when changes happen
    // ===== bug -----
    const destAddress = watch("destAddressDropdown");

    // ===== bug -----
    useEffect(() => {
      // corporateData()
      cityfieldSideeffect()
      packageManager()
      //  edit type,estimation blocker 
      console.log("12333",props?.editType)
      if (props?.editType == "Rebook") {  
        fetchaddress()
      }  
      setIsInitialFreezed(false)
      console.log("toggleerror",toggleAddress,travelType)
      // Clear selected coupon and offer when travel type changes (mirrors EditBookCab behaviour)
      setSelectedCoupon({});
      setSelectedOffer({});
    }, [toggleAddress,travelType,destAddress,isInitialFreezed,sourceAddressDropdown]);

  useEffect(() => {
    cityfieldSideeffect()
    packageManager()
    fetchaddress()
    // console.log("toggleerror",toggleAddress,travelType)
  }, [handleToggle])
  
    

    // let corporateData=()=>{
    
    //   const serviceCityId = getValues("city")?.id;
    //   if (!serviceCityId) return
    //   corporateClientField.onChange("")
    // //  
    //   let obj = {
    //         serviceCityId,
    //         travelType: travelType == AirportToCity && !toggleAddress ? "A2C" : "C2A",
    //       };
    //       getCorporateClientsBySeviceCityIdAndTravelType(obj).then((result) => {
    //         if (result.status == 200) {
    //           const data = result.data.list.map((element) => {
    //             return {
    //               value: element,
    //               label: element.companyName,
    //             };
    //           });
    //           setCorporateClientData(data);
    //           // packageManager()
    //         }
    //       });
    // }
// 
// const { pickupObj, destObj } = fetchAddressData();
// console.log(pickupObj,"--",destObj ,"checker 1")
      let fetchaddress=()=>{
        
      
        const { pickupObj, destObj } = fetchAddressData();
        console.log(pickupObj,"--",destObj ,"checker 1")

        if (pickupObj.address && destObj.address) {
          calculateEstimation(pickupObj, destObj);
        } else {
          clearFareData();
        }
      }
      // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

      // ---- package logic freezer and 

      useEffect(() => {
          packageManager()  
          cityfieldSideeffect()
      }, [customerTypeWatch]);

         
          
      let packageManager= ()=>{
        const serviceCityId =getValues("city")?.id;
        if (!serviceCityId) return;
        const corporateClientId = getValues("corporateClient")?.id || null;
        // const corporateClientId = getValues("")?.id || null;
    
       
        let obj = {
          serviceCityId,
          corporateClientId,
        };
    
        if (corporateClientId && customerTypeWatch == "Corporate") {
          getCorporatePackagesByServiceCity(obj)
            .then((result) => {
              let selectedPackage = undefined;
              let data = result.data.map((element) => {
                return {
                  value: element,
                  label: element.name,
                };
              });
              data.unshift({
                value: {
                  name: "Based on Kilometers",
                  id: null,
                },
                label: "Based on Kilometers",
              });
              setPackagesData(data);
             

              // ----selected packages freezing logic ----------

              if (props?.bookingData?.packageId) {
                selectedPackage = result.data.find(
                  (element) => element.id == props?.bookingData?.packageId
                );
                setSelectedPackage(selectedPackage);
              }
              console.log(selectedPackage, "packageManager 1",props?.bookingData?.packageId);
    
              packageField.onChange(selectedPackage);
              // return {...selectedPackage}
              // setValue("testPack",selectedPackage)
            })
            .catch((err) => {
              showAlert("error", "Unable to fetch packages for selected City");
            });
        } else if(customerTypeWatch == "thirdPartyClient"){
          let clientIdAsNumber= getValues("thirdPartyClientId")

            let obj = {
           
              corporateId:clientIdAsNumber
            };
            console.log(clientIdAsNumber,"disisisis --")
            getPackagesListExt(obj)
            .then((result) => {
              let selectedPackage = undefined;
              let data = result.data?.list.map((element) => {
                return {
                  value: element,
                  label: element.name,
                };
              });
              // data.unshift({
              //   value: {
              //     name: "Based on Kilometers",
              //     id: null,
              //   },
              //   label: "Based on Kilometers",
              // });
              setPackagesData(data);
             

              // ----selected packages freezing logic ----------

              if (props?.bookingData?.packageId) {
                selectedPackage = result.data?.list.find(
                  (element) => element.id == props?.bookingData?.packageId
                );
                setSelectedPackage(selectedPackage);
              }
              // console.log(selectedPackage, "packageManager 1",props?.bookingData?.packageId);
    
              packageField.onChange(selectedPackage);
              // return {...selectedPackage}
              // setValue("testPack",selectedPackage)
            })
            .catch((err) => {
              console.log(err,"errrer")
              showAlert("error", "Unable to fetch packages for selected City");
            });

        }else {
          getPackagesByServiceCity(obj)
            .then((result) => {
              let selectedPackage = undefined;
              let data = result.data.map((element) => {
                return {
                  value: element,
                  label: element.name,
                };
              });
              data.unshift({
                value: {
                  name: "Based on Kilometers",
                  id: null,
                },
                label: "Based on Kilometers",
              });
              setPackagesData(data);
              console.log(
                props?.bookingData?.packageId,
                "props?.bookingData?.packageId"
              );
              if (props?.bookingData?.packageId) {
                selectedPackage = result.data.find(
                  (element) => element.id == props?.bookingData?.packageId
                );
                // setSelectedPackage(selectedPackage);
                console.log(selectedPackage, "packageManager 2")
                return {...selectedPackage}
                
              }
              console.log(selectedPackage, "packageManager 3");
                // return {...selectedPackage}
              packageField.onChange(selectedPackage);
              // setValue("testPack",selectedPackage)
            })
            .catch((err) => {
              showAlert("error", "Unable to fetch packages for selected City");
            });
        }
      }

      
    
    // on changes actions--------------------------
    const handleCitySelectChange = (data) => {
        cityField.onChange(data.value);
        packageManager()
        cityfieldSideeffect()
      };

    const onChangePickUP = (date) => {
        setPickupDate(date);
        if (new Date(date) < new Date()) {
          setDateValidation({
            error: true,
            message: "Pickup Datetime cannot be less than Current Time",
          });
        } else {
          setDateValidation({
            error: false,
            message: null,
          });
        }
      };

      const getAddressData = async (inputValue) => {
        if (inputValue) {
          let obj = {
            key: inputValue,
            isAgentApp: true,
            geoApi: false,
            address: null,
            requestSource: "TMS",
          };
          return fetchLocation(obj).then((result) => {
            if (result.data.length > 0) {
              let data = result.data.map((element) => {
                return {
                  value: element,
                  label: element?.address ? element.address : element,
                };
              });
              return data;
            }
            return [];
          });
        }
      };
    //   ---------------------- airport changes----------
    const handleAirportSelectChange = (data) => {
  
        airportField.onChange(data.value);
        fetchaddress()
      };

    const handleDestSelectChange = (data) => {

        destAddressField.onChange(data.value);
        fetchaddress()
        
      };
    // ---- new
    const handleTraveltype=(data)=>{
      setTravelType(data)
      fetchaddress()
      cityfieldSideeffect()
      packageManager()
    }

      

    const handleCustomAirportSelectChange = (data) => {
      
        const value = data.value;
        const obj = {
          name: value.address,
          lat: value.lat,
          lng: value.lng,
        };
        airportField.onChange(obj);
      };

      const handleSourceSelectChange = (data) => {
        sourceAddressField.onChange(data.value);
        fetchaddress()
      };
      const handlePackageSelectChange = (data) => {
        setCarDetails([]);
        packageField.onChange(data.value);
        fetchaddress()
      };

  const handleUsertype = () => {
    console.log(count, "count");
    setCount((prevCount) => prevCount + 1);
    setValue("corporateClient", "");
    clearFareData();
    packageManager()
  };



      const handleCorporateSelectChange = (data) => {
        corporateClientField.onChange(data.value);
        packageManager()
        clearFareData()
      };
      // ===== ???????
      const handleThirdPartyChange = (data) => {
        // corporateClientField.onChange(data.value);
        // console.log("disisisis",data.value.id)
        let id =data?.value?.id||null
        setValue("thirdPartyClientId",id)
        packageManager()
        clearFareData()
      };

      const handleAggregatorSelectChange = (data) => {
        console.log(">>>>> ID value of Aggregator is ", data);
        aggregatorField.onChange(data.value)
      }
    
      useEffect(() => {
        if (aggregatorField.value?.id) {
          setSelectedAggregator(aggregatorField.value.id);
        } else {
          setSelectedAggregator(null);
        }
        console.log(">>>>>>>>>> selected aggregator value is ::: ", selectedAggregator)
      }, [handleAggregatorSelectChange]);

      const updateAirPortCityState = (serviceId) => {
        let array = [];
        if (serviceId) {
          airportData.forEach((element) => {
            if (element.serviceCityId == serviceId) {
              array.push({
                value: element,
                label: element.name,
              });
            }
          });
        }
        setAirportCityData(array);
      };

      // ----- cab type initializers and coupoun finder
      

        let cityfieldSideeffect=()=>{
          setSelectedCoupon({});
          setSelectedOffer({});
          const serviceCityId = getValues("city")?.id;
          // updateAirPortCityState(serviceCityId);
          if (!serviceCityId) {
            setCarTypeData([]);
            return;
          }
          let obj = {
            serviceCityId,
            travelType: travelType == AirportToCity && !toggleAddress ? "A2C" : "C2A",
          };
          getCarTypes(obj)
          .then((result) => {
            if (!props?.editType == "Edit") {
              clearFareData();
            }
            setCarTypeData(result.data);
          })
          .catch((err) => {
            showAlert("error", "Unable to fetch Car details for selected City");
          });
        // setValue("customerType", "Standard");
        // corporateClientField.onChange("");
        // packageField.onChange("");
        getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
          if (result.status == 200) {
            const data = result.data.list.map((element) => {
              return {
                value: element,
                label: element.companyName,
              };
            });
            setCorporateClientData(data);
          }
        });
    
        const rideType =
          travelType == AirportToCity ? (toggleAddress ? "C2A" : "A2C") : "C2C";
        const isAirportBooking = AirportToCity ? toggleAddress ? false : true : false;
    
        getCoupons({ serviceCityId, rideType })
          .then((result) => {
            if (result.status == 200 && result.data.length > 0) {
              setCouponsData(result.data);
              if(props?.editType == "Edit"){
                console.log("123", "get coupon")
                if(props?.bookingData?.couponid){
                  couponApply(props.bookingData?.couponCode, props.bookingData?.couponId, 0)
                }
              }
            }
          })
          .catch((err) => {
            setSelectedCoupon({});
            console.log("123", "get coupon error")
            setCouponsData([]);
          });

        // Fetch applicable offers if customer is selected
        const custId = getValues("custId");
        if (custId) {
          const carTypeId = carDetails.length > 0 ? carDetails[0].id : null;
          getApplicableOffers({
            customerId: custId,
            serviceCityId,
            carType: carTypeId,
            isAirportBooking,
            bookingSourceType: "TMS",
          }).then((result) => {
            if (result.status == 200 && result.data.length > 0) {
              setOffersData(result.data);
            } else {
              setOffersData([]);
            }
          }).catch(() => setOffersData([]));
        } else {
          setOffersData([]);
        }
}
    
// ---------------------------------booking------------------------------------------------
 // --------------------------------form object helper------------------------------------------------
 const generateRequest = (formValues, selectedCar) => {
  const { pickupObj, destObj, rideType } = fetchAddressData();
  // const numberOfCars = carDetails[selectedCar];

  const numberOfCars = 1;
  const carObj = carTypeData.find((element) => element.id == selectedCar);
  const pickupTime = moment(new Date(pickupDate)).format("hh:mm");
  const pickUpDateFormat = moment(new Date(pickupDate)).format("MM/DD/YYYY");
  const userDetails = getUserDetails();
  const fareObj = estimatedData.find(
    (element) => element.carTypeId == selectedCar
  );

  const obj = {
    userId: userDetails.userId,
    createdById: userDetails.userId,
    packageId: packageField?.value?.id ? packageField.value.id : null,
    packageName: packageField?.value?.id ? packageField.value.name : null,
    currentBookingStatusType: formValues.currentBookingStatusType,
    bookingViaType:travelType == AirportToCity||CityToAirport 
    ? toggleAddress
      ? "CallCenter"
      : "AirportBooking"
    : "CallCenter",
    custName: formValues.customerName,
    custMobile: formValues.phoneNumber,
    pickUpDate: pickUpDateFormat,
    pickUpTime: pickupTime,
    pickUpDateTime: new Date(pickupDate),
    serviceCityId: formValues.city.id,
    createdByUserType: formValues.createdByUserType,
    paymentModeType: paymentMode,
    pickUpAddress: pickupObj.address,
    bookingTotalFare: fareObj.estimatedMinFare,
    bookingTotalDistance: fareObj.estimatedMinKM,
    overviewPolyline: fareObj.overviewPolyline,
    estimatedKm: fareObj.estimatedKm,
    pickUpLat: pickupObj.lat,
    pickUpLng: pickupObj.lng,
    pickUpCenter: [null, null],
    destAddress: destObj.address,
    destLat: destObj.lat,
    destLng: destObj.lng,
    destCenter: [null, null],
    custEmail: formValues.email,
    gender: formValues.gender,
    custId: formValues.custId,
    rideType: rideType,
    isMoveToComplete: formValues.isMoveToComplete,
    noOfCars: carDetails[0]["count"],
    carTypeId: Number(selectedCar),
    carType: carObj.name,
    remark: formValues.instructions,
    isCompanyBooking:
      formValues.customerType == "Corporate" ? "true" : "false",
    thirdPartyClientId: formValues?.thirdPartyClientId ? formValues?.thirdPartyClientId:null,
    corporateClientId:
      formValues.customerType == "Corporate"
        ? formValues.corporateClient?.id
        : null,
    companyName: formValues.corporateClient?.companyName || null,
    isVip: formValues.customerType == "Vip" ? "true" : "false",
    isCouponApplied: selectedCoupon?.couponId ? true : false,
    couponId: selectedCoupon?.couponId ? selectedCoupon?.couponId : null,
    estimatedFare: fareObj.estimatedMinFare,
    discountedEstimateFare: selectedCoupon?.couponId
      ? selectedCoupon?.finalFare
      : selectedOffer?.offerId
      ? selectedOffer?.discountedFinalFare
      : fareObj?.discountedEstimateFare || null,
    isOfferApplied: selectedOffer?.offerId ? true : false,
    offerId: selectedOffer?.offerId ? selectedOffer?.offerId : null,
    aggregatorId : selectedAggregator ? selectedAggregator : null,
    zone:formValues.zone|| "",
  };
  return obj;
};
// --------------------------------booking submit and updation-----------------------------------
const onBookingSubmit = async (formValues) => {
  console.log(formValues,"sdsdsdsdsd")
  if (dateValidation.error) return;
  const selectedCar = carDetails.length > 0 ? carDetails[0].id : 0;
  if (selectedCar && selectedCar != 0 && paymentMode) {
    let obj = generateRequest(formValues, selectedCar);
    if (editTrip) {
      obj["id"] = props?.bookingData?.id;
      obj["megaCabsBookingNo"] = props?.bookingData?.megaCabsBookingNo;
      obj["otp"] = props?.bookingData?.otp;
      obj["userId"] = props?.bookingData?.userId
        ? props?.bookingData.userId
        : props?.bookingData.createdById;
      obj["createdById"] = props?.bookingData?.userId
        ? props?.bookingData.userId
        : props?.bookingData.createdById;
      obj["bookingSourceType"] ="TMS"
      //  props?.bookingData?.bookingSourceType
      //   ? props?.bookingData.bookingSourceType
      //   : null;
      if (!obj["isCouponApplied"] && !obj["isOfferApplied"])
        obj["couponId"] = props?.bookingData?.couponId;
      console.log(obj, "obj");
      props.setShowApiLoader(true);
      editTripData(obj)
        .then(async (result) => {
          console.log(result, "result");
          props.setShowApiLoader(false);
          showAlert("success", "Booking Updated Successfully");
          await props?.onSubmitData?.fetchBookingData();
          props.LargeModaltoggle();
        })
        .catch((err) => {
          props.setShowApiLoader(false);
          showAlert("error", "Something went wrong");
        });
    } else {
      console.log(obj, "obj");
      props.setShowApiLoader(true);
      postBooking(obj)
        .then(async (result) => {
          console.log(result, "result");
          props.setShowApiLoader(false);
          showAlert("success", "Booking Created Successfully");
          await props?.onSubmitData?.fetchBookingData();
          props.LargeModaltoggle();
        })
        .catch((err) => {
          console.log(err.data, "dfjdfjdf");
          console.log(err, "error");
          console.log("error response", err.response);
          props.setShowApiLoader(false);
          showAlert(
            "error",
            err.response.data.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  } else {
    toast.error("Select Car and Payment Mode", {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnFocusLoss: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
};

const onError = (errorInfo) => {
  console.log(errorInfo, "erroringo");
};
    

      
// ------------------------ui----------------  
    const hasDiscountedFare = estimatedData?.some((item) => item?.discountedEstimateFare > 0);

    return( 
    <CommonModal
    isOpen={props.Large}
    title={props.title}
    toggler={props.LargeModaltoggle}
    size="xl" >
    


    <Form 
    onSubmit={handleSubmit(onBookingSubmit, onError)}
    >
        <Row className="book-a-cab">
          <Row className="book-a-cab-form">
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {PhoneNumberLabel}
              </Label>
              <Col lg="8">

              <input
                  className="form-control"
                  {...register("phoneNumber", {
                    required: {
                      value: true,
                      message: "Customer number is required",
                    },
                   
                  })}
                  type="number"
                  disabled
                />
            
                <span style={{ color: "red" }}>
                  {errors?.phoneNumber?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {CustomerNameLabel}
              </Label>
              <Col lg="8">
                <input
                  className="form-control"
                  {...register("customerName", {
                    required: {
                      value: true,
                      message: "Customer Name is required",
                    },
                    pattern: {
                      value: /^[^\s].+[^\s]$/,
                      message: "Invalid Customer name",
                    },
                  })}
                  type="text"
                />
                <span style={{ color: "red" }}>
                  {errors?.customerName?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {City}
                </Label>
              <Col lg="8">
                <div className="city-select">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    value={{
                      label: cityField?.value?.name,
                      value: cityField?.value,

                    }}
                    isDisabled={props.editType == "Edit" ? true : false}
                    onChange={handleCitySelectChange}
                    placeholder="Select City"
                    options={cityData}
                  />
                </div>
                <span style={{ color: "red" }}>
                    {errors?.city?.message}
                    </span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{DateTime}</Label>
              <Col lg="8">
                <DatePicker
                  className="form-control"
                  selected={pickupDate}
                  onChange={(date) => onChangePickUP(date)}
                  timeInputLabel="Time:"
                  minDate={new Date(minDate)}
                  // maxDate={new Date().setDate(new Date().getDate()+5)}
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeInput
                  shouldCloseOnSelect={false}
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                />
                {dateValidation.error ? (
                  <span style={{ color: "red" }}>{dateValidation.message}</span>
                ) : (
                  ""
                )}
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{Email}</Label>
              <Col lg="8">
                <input
                  className="form-control"
                  {...register("email", {
                    required: {
                      value: false,
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Please enter a valid email !",
                    },
                  })}
                  type="text"
                />
                <span style={{ color: "red" }}>
                    {errors?.email?.message}
                    </span> 
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{"Gender"}</Label>
              <Col className="col-lg-8">
                <div className="m-checkbox-inline mb-0 custom-radio-ml">
                  <div className="radio radio-primary">
                    <input
                      id="GenderMale"
                      type="radio"
                      {...register("gender", {
                        required: {
                          value: true,
                          message: "Gender is required",
                        },
                      })}
                      value="M"
                    />
                    <Label className="mb-0" htmlFor="GenderMale">
                      {"Male"}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="GenderFemale"
                      type="radio"
                      value="F"
                      {...register("gender", {
                        required: {
                          value: true,
                          message: "Gender is required",
                        },
                      })}
                    />
                    <Label className="mb-0" htmlFor="GenderFemale">
                      {"Female"}
                    </Label>
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.gender?.message}
                  </span>
                </div>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12" onChange={handleUsertype}>
              <Label className="col-lg-4 col-form-label">
                {"Customer Type"}
              </Label>
              <Col className="col-lg-8">
                <div className="m-checkbox-inline mb-0 custom-radio-ml">
                  <div className="radio radio-primary">
                    <input
                      id="Vipuser"
                      type="radio"
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                      value="Standard"
                    />
                    <Label className="mb-0" htmlFor="Vipuser">
                      Standard
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="Standarduser"
                      type="radio"
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                      value="Vip"
                    />
                    <Label className="mb-0" htmlFor="Standarduser">
                      {Vip}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="CorporateUser"
                      type="radio"
                      value="Corporate"
                      disabled={cityField?.value ? false : true}
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                    />
                    <Label className="mb-0" htmlFor="CorporateUser">
                      {Corporate}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="thirdPartyClient"
                      type="radio"
                      value="thirdPartyClient"
                      disabled={cityField?.value ? false : true}
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Third Party Type is required",
                        },
                      })}
                    />
                    <Label className="mb-0" htmlFor="thirdPartyClient">
                      {"Third Party Client"}
                    </Label>
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.customerType?.message}
                  </span>
                </div>
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12 coorporate-input">
              {customerTypeWatch == "Corporate" ? (
                <Col lg="8">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={true}
                    value={corporateClientData.find((element) => {
                      return (
                        element?.value?.id === corporateClientField?.value?.id
                      );
                    })}
                    onChange={handleCorporateSelectChange}
                    placeholder="Select Corporate Client"
                    options={corporateClientData}
                  />
                </Col>
              ) : (
                ""
              )}
            </FormGroup>
            <FormGroup className="row col-lg-12 coorporate-input">
              {customerTypeWatch == "thirdPartyClient" ? (
                <Col lg="8">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    value={thirdPartyClientData.find((element) => {
                      return (
                        element?.value?.id === getValues("thirdPartyClientId")
                      );
                    })}
                    onChange={handleThirdPartyChange}
                    placeholder="Select third Party Client "
                    options={thirdPartyClientData}
                  />
                </Col>
              ) : (
                ""
              )}
            </FormGroup>

            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {'Aggregator'}
              </Label>
              <Col className="col-lg-8">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={aggregatorList?.id}
                  onChange={handleAggregatorSelectChange}
                  placeholder="Select Aggregator"
                  options={aggregatorList}
                  isDisabled={cityField.value === undefined ? true : false}
                />
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{Instructions}</Label>
              <Col lg="8">
                <textarea
                  className="form-control"
                  {...register("instructions")}
                  type="text"
                />
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12"></FormGroup>
          </Row>
          <Row className="add-address">
            <Card className="travel-details">
              <div
                className={`travel-mode ${travelType == AirportToCity || travelType == CityToAirport
                  ? "active"
                  : ""
                  }`}
                onClick={() => handleTraveltype(AirportToCity)}
              >
                Airport Transfer
              </div>
              <div
                className={`travel-mode ${travelType == CityToCity ? "active" : ""
                  }`}
                onClick={() => handleTraveltype(CityToCity)}
              >
                City Transfer
              </div>
            </Card>
            {travelType == AirportToCity || travelType == CityToAirport ? (
              <AirportTransferComp
              setHandleToggle={setHandleToggle} 
              handleToggle={handleToggle}
                setToggleAddress={setToggleAddress}
                toggleAddress={toggleAddress}
                cityField={cityField}
                airportCityData={airportCityData}
                airportField={airportField}
                handleAirportSelectChange={handleAirportSelectChange}
                handleDestSelectChange={handleDestSelectChange}
                getAddressData={getAddressData}
                handleCustomAirportSelectChange={
                  handleCustomAirportSelectChange
                }
                bookingType={ props?.editType }
                register={register}
                setValue={setValue}
                watch={watch}
              />
            ) : (
              <CityTransferComp
                handleSourceSelectChange={handleSourceSelectChange}
                handleDestSelectChange={handleDestSelectChange}
                getAddressData={getAddressData}
                register={register}
                setValue={setValue}
                watch={watch}
              />
            )}
            <FormGroup className="row col-lg-12 package-nd-distance">
              <div className="estimated-distance col-3">
                {estimatedData.length > 0 ? (
                  estimatedData[0].estimatedKm ? (
                    `${estimatedData[0].estimatedKm} Km`
                  ) : (
                    "NA"
                  )
                ) : (
                  <span>
                    <i className="fa fa-ellipsis-h"></i> Km
                  </span>
                )}
              </div>
              <div className="col-9">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={{
                    label: getValues("packageDropdown")?.name
                      ?getValues("packageDropdown")?.name
                      : "Based on Kilometers",
                    value:getValues("packageDropdown"),
                  }}
                  isDisabled={cityField?.value ? false : true}
                  placeholder="Select Package"
                  options={packagesData}
                  onChange={handlePackageSelectChange}
                />
              </div>
            </FormGroup>

            <Row className="cab-details">
               {carTypeData.length > 0
                ? carTypeData.map((element, index) => {
                  return (
                    <Col key={index} className="col-lg-4">
                       <CabDetails
                         element={element}
                         setCarDetails={setCarDetails}
                         carDetails={carDetails}
                         estimatedData={estimatedData}
                         selectedCoupon={selectedCoupon}
                         setSelectedCoupon={setSelectedCoupon}
                         couponApply={couponApply}
                         selectedOffer={selectedOffer}
                         offerApply={offerApply}
                         editTrip={props?.editType == "Edit"}
                       />
                    </Col>
                  );
                })
                : "Select City to select car type"} 
            </Row>
            {carTypeData.length > 0 && <Row style={{justifyContent:"center",marginTop: "10px",color:"red"}}>
              *exclusive of toll and MCD
            </Row>}
            <Row>
               <Card className="coupon-payment-card">
                {!hasDiscountedFare && (
                <div
                  className="apply-coupon"
                  style={{ width: (selectedCoupon?.couponId || selectedOffer?.offerId) ? "40%" : "30%" }}
                >
                  {selectedCoupon?.couponId ? (
                    <div className="applied-coupon-body">
                      <div style={{ width: "20%" }}>
                        <img
                          src={require("../../../assets/images/coupon-img.png")}
                          className="coupon-img"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                      >
                        <span style={{ fontSize: 12, fontWeight: 500 }}>
                          {selectedCoupon.code}
                        </span>
                        <span style={{ fontSize: 10, fontWeight: 400 }}>
                          (Coupon Applied)
                        </span>
                      </div>
                      <button
                        className="remove-btn"
                        type="button"
                        onClick={() => {
                          setSelectedCoupon({});
                          setSelectedOffer({});
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ) : selectedOffer?.offerId ? (
                    <div className="applied-coupon-body">
                      <div style={{ width: "20%" }}>
                        <img
                          src={require("../../../assets/images/coupon-img.png")}
                          className="coupon-img"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                      >
                        <span style={{ fontSize: 12, fontWeight: 500 }}>
                          {selectedOffer.offerCode}
                        </span>
                        <span style={{ fontSize: 10, fontWeight: 400 }}>
                          (Offer Applied)
                        </span>
                      </div>
                      <button
                        className="remove-btn"
                        type="button"
                        onClick={() => {
                          setSelectedOffer({});
                          setSelectedCoupon({});
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="coupon-btn"
                      disabled={carDetails.length > 0 ? false : true}
                      onClick={() => {
                        setIsCouponOpen(true);
                      }}
                    >
                      <img
                        src={require("../../../assets/images/coupon-img.png")}
                        className="coupon-img"
                      />
                      Coupon &amp; Offer
                    </button>
                  )}
                </div>
                )}
                  <CouponsModal
                    isOpen={isCouponOpen}
                    title={"Coupon & Offer"}
                    toggler={() => setIsCouponOpen(!isCouponOpen)}
                    couponsData={couponsData}
                    offersData={offersData}
                    setCouponsData={setCouponsData}
                    couponApply={couponApply}
                    offerApply={offerApply}
                    carDetails={carDetails}
                    couponSearch={couponSearch}
                  />
                <div
                  className="payment-details"
                  style={{ width: hasDiscountedFare ? "100%" : ((selectedCoupon?.couponId || selectedOffer?.offerId) ? "58%" : "68%") }}
                >
                  <div
                    className={`payment-mode ${paymentMode == "CreditCustomer" ? "active" : ""
                      }`}
                    onClick={() => setPaymentMode("CreditCustomer")}
                  >
                    <i className="fa fa-credit-card-alt"></i>
                    Pre Paid
                  </div>
                  <div
                    className={`payment-mode ${paymentMode == "Cash" ? "active" : ""
                      }`}
                    onClick={() => setPaymentMode("Cash")}
                  >
                    <i className="fa fa-money"></i>
                    Post Paid
                  </div>
                </div>
              </Card> 
            </Row>

            <Row className="submit-booking">
              <button type="submit" className="btn submit-button">
                {bookingType == "Edit" ? "Update" : bookingType} 
              </button>
            </Row>
          </Row>
        </Row>
      </Form>



    </CommonModal>
    )
}

export default BookEdit;
